var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: { "is-disabled": _vm.isDisabled },
      attrs: { "data-component": "agent-picker-input" },
    },
    [
      _c("div", { staticClass: "label" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.label || _vm.$t("hitl.modules.agent-picker.input-label")
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "input",
          class: { "is-disabled": _vm.isDisabled },
          attrs: { "data-input": "" },
          on: { click: _vm.onInputClick },
        },
        [
          !!_vm.agent
            ? _c("agent-avatar", {
                attrs: { avatar: _vm.avatar, person: _vm.agent },
              })
            : _vm._e(),
          _vm._v(" "),
          !!_vm.agent
            ? _c("span", { staticClass: "username" }, [
                _vm._v("\n      " + _vm._s(_vm.username) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.agent
            ? _c("span", { staticClass: "placeholder" }, [
                _vm._v("\n      " + _vm._s(_vm.placeholderText) + "\n    "),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }